import Vue from 'vue';
import Alert from './cErrorDialog.vue';
let AlertConstructor = Vue.extend(Alert); // 返回一个“扩展实例构造器” 

let AlertModal = (o) => {
    let alertDom = new AlertConstructor({
        el: document.createElement('div') //将Alert组件挂载到新创建的div上 
    })
    document.body.appendChild(alertDom.$el); //把Alert组件的dom添加到body里 
    // 标题
    alertDom.title = o.title || '';
    // 单条内容
    alertDom.content = o.content;
    // 关闭按钮
    alertDom.cancelBtn = o.cancelBtn;
    alertDom.left = o.left || 'cancle';
    alertDom.right = o.right || 'ok';

    // 弹框三个事件 右上角关闭 确定 取消
    alertDom.a_close = o.close || null;
    alertDom.a_confirm = o.confirm || null;
    alertDom.a_cancel = o.cancel || null;

}
export default AlertModal;


// WEBPACK FOOTER //
// ./src/components/Dialog/cErrorDialog.js